import { useQuery, useSuspenseQuery } from "@tanstack/react-query"

import { newNotificationsQuery, notificationsQuery } from "../queries"
import { useQueryRefresher } from "~/shared/lib/hooks/useQueryRefresher"


export function useNotificationsQuery() {	
	return useQuery(notificationsQuery)
}

export function useNotificationsRefresher() {	
	return useQueryRefresher(notificationsQuery)
}

export function useNewNotifications() {	
	return useSuspenseQuery(newNotificationsQuery).data.userNotificationList
}

export function useNewNotificationsRefresher() {
	return useQueryRefresher(newNotificationsQuery)
}
